import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const TimeLine = ({ item, isLeft, setSelectedItem }) => {
  const [ref, inView] = useInView({ triggerOnce: true });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, x: isLeft ? -150 : 150 }}
      animate={inView ? { opacity: 1, x: 0 } : {}}
      transition={{ duration: 0.7 }}
      className="w-full flex"
    >
      {/* CARD */}
      <motion.div
        whileHover={{
          scale: 1.04,
        }}
        className="w-full h-[320px] sm:h-[360px] md:h-[380px] bg-black/20 backdrop-blur-md border border-white/20 rounded-2xl p-4 shadow-[0_0_30px_rgba(255,215,0,0.2)] hover:shadow-[0_0_60px_rgba(255,215,0,0.5)] transition-all duration-300 flex flex-col justify-between"
      >
        {/* DOT */}
        <div className="hidden md:flex justify-center relative">
          <div className="w-3 h-3 bg-yellow-400 rounded-full animate-ping absolute"></div>
          <div className="w-3 h-3 bg-yellow-600 rounded-full"></div>
        </div>

        {/* CLICK AREA */}
        <div
          onClick={() => setSelectedItem(item)}
          className="cursor-pointer flex flex-col h-full justify-between"
        >
          {/* IMAGE */}
          <div className="h-40 sm:h-44 md:h-48 flex justify-center items-center">
            <img
              src={Array.isArray(item.url) ? item.url[0] : item.url}
              alt={item.title}
              className="h-full object-contain"
            />
          </div>

          {/* TEXT */}
          <div>
            <h3 className="mt-2 text-sm sm:text-base md:text-lg text-[#800000] text-center font-bold line-clamp-2">
              {item.title}
            </h3>

            <p className="text-xs sm:text-sm font-semibold text-black mt-2 line-clamp-3">
              {item.description}
            </p>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default TimeLine;